import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

/* Public Pages */
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProductsPage from "./pages/ProductsPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";

/* Pages */
import CategoriesPage from "./admin/pages/CategoriesPage";
import TagsPage from "./admin/pages/TagsPage";

/* Analytics */
import BannerAnalyticsPage from "./admin/pages/BannerAnalyticsPage";

/* Services */
import CustomSoftwareDevelopment from "./pages/services/CustomSoftwareDevelopment";
import ManagementSystemConsulting from "./pages/services/ManagementSystemConsulting";
import EcommerceApplications from "./pages/services/EcommerceApplications";
import SoftwareLicensing from "./pages/services/SoftwareLicensing";

/* Products */
import WorkEikon from "./pages/products/WorkEikon";
import Quinthex from "./pages/products/Quinthex";
import Schematz from "./pages/products/Schematz";
import Fundtz from "./pages/products/Fundtz";

/* Admin */
import AdminLoginPage from "./admin/pages/AdminLoginPage";
import DashboardPage from "./admin/pages/DashboardPage";

import PostsPage from "./admin/pages/PostsPage";
import CreatePostPage from "./admin/pages/CreatePostPage";
import EditPostPage from "./admin/pages/EditPostPage";

import BannersPage from "./admin/pages/BannersPage";
import EditBannerPage from "./admin/pages/EditBannerPage";
import CreateBannerPage from "./admin/pages/CreateBannerPage";

import AdminLayout from "./admin/layouts/AdminLayout";
import ProtectedRoute from "./admin/components/ProtectedRoute";


function AppContent() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen">

      {!isAdminRoute && <Navbar />}

      <Routes>

        {/* PUBLIC ROUTES */}

        <Route path="/" element={<HomePage />} />

        <Route path="/about" element={<AboutPage />} />

        <Route path="/services" element={<ServicesPage />} />

        <Route
          path="/services/custom-software-development"
          element={<CustomSoftwareDevelopment />}
        />

        <Route
          path="/services/management-system-consulting"
          element={<ManagementSystemConsulting />}
        />

        <Route
          path="/services/ecommerce-applications"
          element={<EcommerceApplications />}
        />

        <Route
          path="/services/software-licensing"
          element={<SoftwareLicensing />}
        />

        <Route path="/products" element={<ProductsPage />} />

        <Route
          path="/products/workeikon"
          element={<WorkEikon />}
        />

        <Route
          path="/products/quinthex"
          element={<Quinthex />}
        />

        <Route
          path="/products/schematz"
          element={<Schematz />}
        />

        <Route
          path="/products/fundtz"
          element={<Fundtz />}
        />

        <Route path="/contact" element={<ContactPage />} />

        <Route path="/blog" element={<BlogPage />} />

        <Route
          path="/blog/:slug"
          element={<BlogPostPage />}
        />

        {/* ADMIN LOGIN */}

        <Route
          path="/admin/login"
          element={<AdminLoginPage />}
        />

        {/* ADMIN ROUTES */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <DashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/posts"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PostsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/posts/create"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CreatePostPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/posts/:postId/edit"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <EditPostPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/categories"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <CategoriesPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

        <Route
          path="/admin/tags"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <TagsPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

        <Route
          path="/admin/banners"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <BannersPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

        <Route
          path="/admin/banners/create"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <CreateBannerPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

        <Route
          path="/admin/banners/:bannerId/edit"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <EditBannerPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

        <Route
          path="/admin/banner-analytics"
          element={
          <ProtectedRoute>
            <AdminLayout>
              <BannerAnalyticsPage />
            </AdminLayout>
          </ProtectedRoute>}
        />

      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;